$(document).ready(function () {
    if (document.getElementById('module1[module1PrimesRecurrIndemBrut]')) {
        function calculNet() {
            const pertePrime1 = module1Brut.value !== '' ? parseInt(module1Brut.value) : null;
            const pertePrime2 = module2Brut.value !== '' ? parseInt(module2Brut.value) : null;
            const salaire = !mil && salaireBrut.value !== '' ? parseInt(salaireBrut.value) : null;
            const indice = indiceSoldeTraitement.value !== '' ? parseInt(indiceSoldeTraitement.value) : null;
            const pertePrimeAccess = primeAccessBrut.value !== '' ? parseInt(primeAccessBrut.value) : null;

            $.ajax({
                url: '/assurance-perte-de-revenus/valeurs-nettes',
                type: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify({
                    'code_activite': codeActivite,
                    'perte_prime_1': pertePrime1,
                    'perte_prime_2': pertePrime2,
                    'salaire': salaire,
                    'indice': indice,
                    'perte_prime_access': pertePrimeAccess
                }),
                success: function (data) {
                    if (data.module1?.prime_perte > 0) {
                        module1Net.value = data.module1.prime_perte;
                    } else {
                        module1Net.value = '';
                    }

                    if (data.module2?.prime_perte > 0) {
                        module2Net.value = data.module2.prime_perte
                    } else {
                        module2Net.value = '';
                    }

                    if (data.module3) {
                        salaireBrut.value = data.module3.salaire_brut > 0 ?
                            data.module3.salaire_brut : '';
                        salaireNet.value = data.module3.salaire_net > 0 ?
                            data.module3.salaire_net : '';

                        primeAccessNet.value = data.module3.prime_access > 0 ?
                            data.module3.prime_access : '';
                    } else {
                        salaireNet.value = '';

                        if (primeAccessBrut.value === '') {
                            primeAccessNet.value = '';
                        }
                    }
                },
                error: function() {
                    module1Net.value = '';
                    module2Net.value = '';
                    salaireNet.value = '';
                    primeAccessNet.value = '';
                }
            })
        }

        function updateSalaireInputs() {
            if (CDEFaIndiceOUI?.checked) {
                salaireBrut = document.getElementById('module3Cdef[module3TraitementMensuDecla' + psc + '][module3TraitementMensuDeclaBrut]');
                salaireNet = document.getElementById('module3Cdef[module3TraitementMensuDecla' + psc + '][module3TraitementMensuDeclaNet]');

                primeAccessBrut = document.getElementById('module3Cdef[module3PrimesAccessTraitementDeclaCdef][module3PrimesAccessTraitementDeclaCdefBrut]');
                primeAccessNet = document.getElementById('module3Cdef[module3PrimesAccessTraitementDeclaCdef][module3PrimesAccessTraitementDeclaCdefNet]');
            } else {
                salaireBrut = document.getElementById('module3Cdef[module3SalaireMensuDecla' + psc + '][module3SalaireMensuDeclaBrut]');
                salaireNet = document.getElementById('module3Cdef[module3SalaireMensuDecla' + psc + '][module3SalaireMensuDeclaNet]');

                primeAccessBrut = document.getElementById('module3Cdef[module3PrimesAccessSalaireDeclaCdef][module3PrimesAccessSalaireDeclaCdefBrut]');
                primeAccessNet = document.getElementById('module3Cdef[module3PrimesAccessSalaireDeclaCdef][module3PrimesAccessSalaireDeclaCdefNet]');
            }

            salaireBrut.onchange = primeAccessBrut.onchange = calculNet;
        }

        const profession = document.querySelector('input[name="profession"]').value;
        const mil = profession === 'MIL';
        const arme = document.querySelector('input[name="arme"]').value;
        const psc = document.querySelector('input[name="protectionPsc"]').value === 'OUI' ? 'Psc' : '';
        const codeActivite = mil ? arme : 'CDEF';

        const module1Brut = document.getElementById('module1[module1PrimesRecurrIndemBrut]');
        const module1Net = document.getElementById('module1[module1PrimesRecurrIndemNet]');

        const module2Brut = document.getElementById('module2[module2PrimesRecurrMaintBrut]');
        const module2Net = document.getElementById('module2[module2PrimesRecurrMaintNet]');

        let indiceSoldeTraitement, salaireBrut, salaireNet, primeAccessBrut, primeAccessNet, CDEFaIndiceOUI, CDEFaIndiceNON;

        if (mil) {
            indiceSoldeTraitement = document.getElementById('module3Mil[module3IndiceSolde' + psc + ']');

            salaireBrut = document.getElementById('module3Mil[module3SoldeMensuDecla' + psc + '][module3SoldeMensuDeclaBrut]');
            salaireNet = document.getElementById('module3Mil[module3SoldeMensuDecla' + psc + '][module3SoldeMensuDeclaNet]');

            primeAccessBrut = document.getElementById('module3Mil[module3PrimesAccessDeclaMil][module3PrimesAccessDeclaMilBrut]');
            primeAccessNet = document.getElementById('module3Mil[module3PrimesAccessDeclaMil][module3PrimesAccessDeclaMilNet]');
        } else {
            CDEFaIndiceOUI = document.getElementById('CDEFaIndice_OUI');
            CDEFaIndiceNON = document.getElementById('CDEFaIndice_NON');
            CDEFaIndiceOUI.onchange = CDEFaIndiceNON.onchange = updateSalaireInputs;
            updateSalaireInputs();

            indiceSoldeTraitement = document.getElementById('module3Cdef[module3IndiceTraitement' + psc + ']');
        }

        module1Brut.onchange = module2Brut.onchange = primeAccessBrut.onchange = indiceSoldeTraitement.onchange = calculNet;

        calculNet();
    }
});
